import { Component, OnInit } from "@angular/core";
import { UtilsService } from "app/auth/service/utils.service";
import moment from "moment";
import { AuthenticationService } from "../../../../auth/service";
import { AbsencesService } from "../../../../auth/service/absences.service";
import { ICurrentUser } from "app/auth/models/user-interface";

@Component({
  selector: "app-summary-absences",
  templateUrl: "./summary-absences.component.html",
  styleUrls: ["./summary-absences.component.scss"],
})
export class SummaryAbsencesComponent implements OnInit {
  public me: ICurrentUser;
  public residual_holidays: string;
  public residual_permissions: string;

  constructor(
    private _authenticationService: AuthenticationService,
    public _utilsService: UtilsService,
    public _absenceService: AbsencesService,
  ) {
    this.me = _authenticationService.getCurrentUser();
    if (this.me.residual_holidays === null || this.me.residual_holidays === undefined) {
      this.residual_holidays = "0g";
    } else {
      this.residual_holidays = parseInt(this.me.residual_holidays) > 0 ? `${"+" + this.me.residual_holidays + "g"}` : `${this.me.residual_holidays + "g"}`;
    }

    if (this.me.residual_permissions === null || this.me.residual_permissions === undefined) {
      this.residual_permissions = "0g";
    } else {
      this.residual_permissions = parseInt(this.me.residual_permissions) > 0 ? `${"+" + this.me.residual_permissions + "h"}` : `${this.me.residual_permissions + "h"}`;
    }
  }

  async ngOnInit() {
    await this._absenceService.getMineAbsences();
  }

  getFormat(date, absence) {
    if (absence.type.category === "permesso") {
      return moment(date).format("DD/MM/YY HH:mm");
    } else {
      return moment(date).format("DD/MM/YYYY");
    }
  }

  getLastUpdateDate() {
    const date = moment(this._utilsService.themeConfiguration.last_update_residual_absences);
    date.startOf("month");
    return this._utilsService.formatDate(date);
  }
}
